import type { FC } from 'react';
import React from 'react';
import { styled } from '@compiled/react';

import { Flex } from '@atlaskit/primitives/compiled/flex';
import { token } from '@atlaskit/tokens';

import {
	ContentIcon,
	QuickActions,
	Subtitle,
	LastAction,
	StatusLozenge,
	Title,
	SocialProof,
	Excerpt,
	PageLink,
	PageCardContainer,
} from '../Items/index.ts';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const GridCard = styled.div({
	display: 'flex',
	flexDirection: 'column',
	height: 'calc(100% - 28px)',
	width: 'calc(100% - 32px)',
	maxHeight: '260px',
	padding: `${token('space.150')} ${token('space.200')} ${token('space.200')} ${token('space.200')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TitleContainer = styled.div({
	margin: `${token('space.200')} 0 ${token('space.050')} 0`,
	font: token('font.heading.medium'),
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	overflowWrap: 'break-word',
	display: '-webkit-box',
	WebkitLineClamp: '2',
	WebkitBoxOrient: 'vertical',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FooterContainer = styled.div({
	flex: '1 0 auto',
	display: 'flex',
	alignItems: 'flex-end',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Footer = styled.div({
	width: '100%',
	marginTop: token('space.200'),
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
});

export const GridView: FC = () => {
	// ⚠️ WARNING: Do you need to add conditional logic? Please refer to README#Views ⚠️
	return (
		<PageCardContainer isListitem>
			<PageLink />
			<GridCard data-testid="page-card-grid-view">
				<Flex alignItems="center" justifyContent="space-between">
					<ContentIcon />
					<QuickActions hidden />
				</Flex>
				<TitleContainer>
					<Title />
				</TitleContainer>
				<Subtitle />
				<StatusLozenge isInColumn />
				<Excerpt />
				<FooterContainer>
					<Footer>
						<LastAction />
						<SocialProof />
					</Footer>
				</FooterContainer>
			</GridCard>
		</PageCardContainer>
	);
};
